import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {
  fetchRoomHistory,
  selectRoomHistory,
  selectRoomHistoryLoading
} from 'ducks/allocations';
import {ActivityLogEntry} from 'components/ActivityLog/components/';
import {activityLogMapper} from 'components/ActivityLog/utils';
import Loading from 'components/Loading/';

import './styles.css';

class RoomHistory extends React.Component<any> {
  fetchRoomHistory = () => {
    const {locationRef, roomId} = this.props;
    this.props.fetchRoomHistory({locationRef, roomId});
  };

  componentDidMount() {
    this.fetchRoomHistory();
  }

  render() {
    const {roomHistory, roomHistoryLoading} = this.props;

    return (
      <div className="RoomHistory">
        {roomHistoryLoading && <Loading />}
        {!roomHistoryLoading &&
          roomHistory.map((entry, index) => {
            const {
              icon,
              action,
              description,
              actionDateTime
            } = activityLogMapper(entry);

            return (
              <ActivityLogEntry
                key={index}
                activityIcon={icon}
                action={action}
                description={description}
                actionDateTime={actionDateTime}
              />
            );
          })}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    roomHistory: selectRoomHistory(state),
    roomHistoryLoading: selectRoomHistoryLoading(state)
  };
};

const mapDispatchToProps = {
  fetchRoomHistory
};

export default connect(mapStateToProps, mapDispatchToProps)(RoomHistory);
